import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChartHistoryComponent } from './fi-chart-history.component';

@NgModule({
    imports: [CommonModule],
    declarations: [FiChartHistoryComponent],
    exports: [FiChartHistoryComponent],
})
export class FiChartHistoryModule {}
